export default {
  data() {
    return {
      errors: {}
    }
  },
  methods: {
    setErrors(errors) {
      this.errors = errors;
    }
  },
}
